module.exports = __webpack_public_path__ + "media/Images/check-table-7a85507236c3628dc8a17ac87818cd52.svg";